/* eslint-disable */
<template>
  <section class="history-page">
    <vue-basic-alert :duration="400" ref="alert" />

    <!-- Not logged in -->
    <div v-if="!user" class="login-prompt">
      <div class="login-card">
        <div class="login-icon">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"/>
          </svg>
        </div>
        <h2>Authentication Required</h2>
        <p>Please sign in to view your booking history.</p>
        <router-link class="login-btn" to="/login">Sign In to Continue</router-link>
      </div>
    </div>

    <!-- Logged in -->
    <div v-else class="page-body">

      <!-- ── Page Header ── -->
      <div class="page-header">
        <div class="header-left">
          <div class="header-bar"></div>
          <div>
            <p class="breadcrumb-label">Online Services | මාර්ගගත සේවාවන්</p>
            <h1 class="page-title">Booking History</h1>
            <p class="page-subtitle">ඔබගේ මාර්ගගත වෙන් කිරීම් ඉතිහාසය</p>
          </div>
        </div>
        <router-link to="/onlinebooking" class="back-btn" @click="scrollToTop()">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 19l-7-7m0 0l7-7m-7 7h18"/>
          </svg>
          Online Booking
        </router-link>
      </div>

      <!-- ── Table Card ── -->
      <div class="form-card">
        <div class="card-header">
          <div class="step-badge">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"/>
            </svg>
          </div>
          <div>
            <h2 class="card-title">Booking Requests</h2>
            <p class="card-desc">{{ filteredData.length }} record{{ filteredData.length !== 1 ? 's' : '' }} found</p>
            <!-- <p class="card-desc">{{ data.length }} record{{ data.length !== 1 ? 's' : '' }} found</p> -->
          </div>
        </div>
        <!-- Search bar -->
<div class="search-wrap">
  <div class="search-input-wrap">
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-4.35-4.35M17 11A6 6 0 105 11a6 6 0 0012 0z"/>
    </svg>
    <input
      type="text"
      v-model="search"
      placeholder="Search by name, service, status, phone..."
      class="search-input"
    />
    <button v-if="search" class="search-clear" @click="search = ''">✕</button>
  </div>
  <span class="search-count">{{ filteredData.length }} record{{ filteredData.length !== 1 ? 's' : '' }} found</span>
</div>
        <!-- Table -->
        <div class="table-wrap">
          <table class="data-table">
            <thead>
              <tr>
                <th>#</th>
                <th>Request <br>Date(From)</th>
                <th>Request <br>Date(To)</th>
                <th>Service</th>
                <th>Name</th>
                <th>Address</th>
                <th>Telephone</th>
                <th>Amount (Rs.)</th>
                <th>Status</th>
                <th>Pay</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="paginatedData.length === 0">
                <td colspan="10" class="empty-row">No booking records found.</td>
              </tr>
              <tr v-for="(item, index) in paginatedData" :key="index">
                <td class="idx-cell">{{ (currentPage - 1) * itemsPerPage + index + 1 }}</td>
                <td class="date-cell">{{ formatDate(item.req_date_from) }}</td>
                <td class="date-cell">{{ formatDate(item.req_date_to) }}</td>
                <td class="service-cell">
                  <span class="service-tag">{{ item.service_type }}</span>
                </td>
                <td class="name-cell">{{ item.name }}</td>
                <td class="addr-cell">{{ item.address }}</td>
                <td class="phone-cell">{{ item.mobile }}</td>
                <td class="amount-cell">
                  <span v-if="item.amount == 0" class="not-updated">Not Updated</span>
                  <span v-else>{{ Number(item.amount).toLocaleString('en-LK', { minimumFractionDigits: 2 }) }}</span>
                </td>

                <!-- Status badge -->
                <td class="status-cell">
                  <span class="status-badge" :class="'status-' + item.payment_status">
                    {{ item.payment_status }}
                  </span>
                  <span v-if="item.payment_status === 'canceled'" class="cancel-reason">
                    Reason: {{ item.feedback }}
                  </span>
                </td>

                <!-- Pay button -->
                <td class="action-cell">
                  <button v-if="item.amount != 0 && item.payment_status !== 'paid'"
                    class="pay-btn"
                    @click="payReq(item.ob_id, item.service_type, item.sabha_code, item.vote, item.amount)">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z"/>
                    </svg>
                    Pay
                  </button>
                  <span v-else class="dash">—</span>
                </td>

                <!-- Cancel / Delete button -->
                <td class="action-cell">
                  <button v-if="item.payment_status === 'waiting'"
                    class="delete-btn"
                    @click="delReq(item.ob_id)">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/>
                    </svg>
                    Delete
                  </button>
                  <span v-else-if="item.payment_status === 'paid'" class="dash">—</span>
                  <button v-else class="cancel-btn" @click="cancelReq(item.ob_id)">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
                    </svg>
                    Cancel
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Pagination -->
        <div class="pagination">
          <button class="page-btn" @click="prevPage($event)" :disabled="currentPage === 1">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"/>
            </svg>
          </button>
          <span class="page-info">Page {{ currentPage }} of {{ totalPages || 1 }}</span>
          <button class="page-btn" @click="nextPage($event)" :disabled="currentPage === totalPages || totalPages === 0">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/>
            </svg>
          </button>
        </div>

      </div><!-- /form-card -->

      <!-- Legend -->
      <div class="legend-row">
        <p class="legend-title">Status Legend:</p>
        <div class="legend-items">
          <span class="status-badge status-waiting">waiting</span>
          <span class="status-badge status-processing">processing</span>
          <span class="status-badge status-payment">payment</span>
          <span class="status-badge status-paid">paid</span>
          <span class="status-badge status-canceled">canceled</span>
        </div>
      </div>

    </div>
  </section>
</template>


<script>
import axios from "axios";
import { mapMutations, mapState } from "vuex";
import VueBasicAlert from 'vue-basic-alert';

export default {
  name: "OnlineBookingHistory",
  components: { VueBasicAlert },
  data() {
    return {
      userNic: '', Nic: '',
      matchUser: undefined,
      currentDate: new Date(),
      itemsPerPage: 20,
      currentPage: 1,
      data: [],
      onlinPaydata: [], nextid: '', search: "",
    };
  },
  created() {
    this.getSessionData();
    // this.fetchPaymentHistory();
  },
  computed: {
  ...mapState(["user"]),

  filteredData() {
  if (!this.search.trim()) return this.data;
  const q = this.search.toLowerCase().trim();

  return this.data.filter(item => {
    // Format the date the same way it's displayed in the table
    const formattedDate = item.req_date_from ? this.formatDate(item.req_date_from) : '';

    return (
      formattedDate.includes(q) ||                          // e.g. "2024-06" or "2024-06-15"
      item.name?.toLowerCase().includes(q) ||
      item.service_type?.toLowerCase().includes(q) ||
      item.payment_status?.toLowerCase().includes(q) ||
      item.mobile?.toLowerCase().includes(q) ||
      item.address?.toLowerCase().includes(q)
    );
  });
},

  paginatedData() {
    const start = (this.currentPage - 1) * this.itemsPerPage;
    return this.filteredData.slice(start, start + this.itemsPerPage);
  },

  totalPages() {
    return Math.ceil(this.filteredData.length / this.itemsPerPage);
  },
},
watch: {
  search() {
    this.currentPage = 1;
  },
},
  methods: {
    ...mapMutations(["setUser"]),

    scrollToTop() { window.scrollTo(0, 0); },

    async MatchUser(nic) {
      let data1 = await axios.get('/customersdata/' + nic);
      this.matchUser = data1.data;
    },

    // async getSessionData() {
    //   const data2 = JSON.parse(sessionStorage.getItem('Userdata'));
    //   if (data2) { this.Nic = data2.Unic; }
    //   await this.MatchUser(this.Nic);
    //   this.setUser(this.matchUser);
    // },
async getSessionData() {
  const data2 = JSON.parse(sessionStorage.getItem('Userdata'));
  if (data2) { this.Nic = data2.Unic; }
  await this.MatchUser(this.Nic);
  this.setUser(this.matchUser);
  await this.fetchPaymentHistory(); // ← call here after user is ready
},
    formatDate(givedate) {
      const date = new Date(givedate);
      const y = date.getFullYear();
      const m = String(date.getMonth() + 1).padStart(2, '0');
      const d = String(date.getDate()).padStart(2, '0');
      return `${y}-${m}-${d}`;
    },

    // async fetchPaymentHistory() {
    //   try {
    //     let response = await axios.get('/onbookingrequest/' + this.user.cus_nic);
    //     this.data = response.data;
    //   } catch (error) {
    //     console.error('Error fetching booking history:', error);
    //   }
    // },
    async fetchPaymentHistory() {
  try {
    if (!this.user || !this.user.cus_nic) {
      console.error("User not loaded yet");
      return;
    }
    let response = await axios.get('/onbookingrequest/' + this.user.cus_nic);
    this.data = response.data;
  } catch (error) {
    console.error('Error fetching booking history:', error);
  }
},
    nextPage(event) {
      event.preventDefault();
      if (this.currentPage < this.totalPages) this.currentPage++;
    },

    prevPage(event) {
      event.preventDefault();
      if (this.currentPage > 1) this.currentPage--;
    },

    async cancelReq(id) {
      await axios.put("/onbookingrequestupdate/" + id, { payment_status: 'canceled' });
      this.$refs.alert.showAlert('success', 'Your Request has been Canceled!');
      const response = await axios.get('/onbookingrequest/' + this.user.cus_nic);
      this.data = response.data;
    },

    async delReq(did) {
      if (!confirm("Are you sure you want to delete this request?")) return;
      await axios.delete("/deletereq/" + did);
      this.$refs.alert.showAlert('success', 'Your Request has been Deleted!');
      const response = await axios.get('/onbookingrequest/' + this.user.cus_nic);
      this.data = response.data;
    },

    async payReq(rid, type, saba, payvote, amount) {
      this.onlinPaydata = (await axios.get('/genarateinvonline/' + saba)).data;
      let lastGennum = parseInt(this.onlinPaydata[0].gen_num);
      let InvouceNum = saba.concat(this.currentDate.getMonth(), this.currentDate.getFullYear(), lastGennum);
      this.nextid = lastGennum + 1;
      await axios.put('/updateinvonline/' + saba, { gen_num: this.nextid });
      sessionStorage.setItem('reqId', JSON.stringify({
        req_ID: rid, ser_type: type, req_vote: payvote,
        req_saba: saba, amount, invoiceNum: InvouceNum,
      }));
      this.$router.push("/onlinebookinginvoice");
    },
  },
};
</script>


<style scoped>
@import url('https://fonts.googleapis.com/css2?family=DM+Sans:opsz,wght@9..40,300;9..40,400;9..40,500;9..40,600;9..40,700&family=DM+Serif+Display&display=swap');

* { box-sizing: border-box; }

/* ── Page ── */
.history-page {
  min-height: 100vh;
  background: #f2f0ec;
  font-family: 'DM Sans', sans-serif;
  padding: 2rem 1.5rem 4rem;
}
.page-body { max-width: 1200px; margin: 0 auto; }

/* ── Login Prompt ── */
.login-prompt { display: flex; align-items: center; justify-content: center; min-height: 80vh; }
.login-card {
  background: #fff; border-radius: 1.4rem; padding: 4rem 3.5rem;
  text-align: center; max-width: 420px; width: 100%;
  box-shadow: 0 8px 30px rgba(100,50,30,0.10);
}
.login-icon {
  width: 6rem; height: 6rem;
  background: linear-gradient(135deg, #7c2d12, #c2440a);
  border-radius: 50%; display: flex; align-items: center; justify-content: center;
  margin: 0 auto 1.8rem;
}
.login-icon svg { width: 2.8rem; height: 2.8rem; stroke: #fff; }
.login-card h2 { font-family: 'DM Serif Display', serif; font-size: 2.2rem; color: #1c0f0a; margin: 0 0 0.8rem; }
.login-card p  { font-size: 1.4rem; color: #7a6258; margin: 0 0 2rem; }
.login-btn {
  display: inline-block; padding: 1rem 2.6rem;
  background: linear-gradient(135deg, #7c2d12, #c2440a);
  color: #fff; border-radius: 0.8rem; font-size: 1.45rem; font-weight: 600;
  text-decoration: none; transition: all 0.2s;
}
.login-btn:hover { transform: translateY(-1px); box-shadow: 0 6px 18px rgba(124,45,18,0.35); }

/* ── Page Header ── */
.page-header {
  display: flex; align-items: flex-start; justify-content: space-between;
  margin-bottom: 2.4rem; gap: 1.5rem; flex-wrap: wrap;
}
.header-left { display: flex; align-items: flex-start; gap: 1.4rem; }
.header-bar {
  width: 5px; min-height: 72px; border-radius: 99px;
  background: linear-gradient(180deg, #7c2d12, #c2440a);
  flex-shrink: 0; margin-top: 4px;
}
.breadcrumb-label { font-size: 1.2rem; font-weight: 500; letter-spacing: 0.12em; text-transform: uppercase; color: #9a6652; margin: 0 0 0.3rem; }
.page-title { font-family: 'DM Serif Display', serif; font-size: 2.6rem; color: #1c0f0a; margin: 0 0 0.3rem; }
.page-subtitle { font-size: 1.3rem; color: #9a8070; margin: 0; }

.back-btn {
  display: inline-flex; align-items: center; gap: 0.6rem;
  padding: 0.85rem 1.8rem; border: 1.5px solid #c2440a;
  color: #c2440a; background: #fff; border-radius: 0.8rem;
  font-family: 'DM Sans', sans-serif; font-size: 1.35rem; font-weight: 500;
  text-decoration: none; transition: all 0.2s; white-space: nowrap;
}
.back-btn svg { width: 1.6rem; height: 1.6rem; }
.back-btn:hover { background: #c2440a; color: #fff; }

/* ── Card ── */
.form-card {
  background: #fff; border: 1px solid #e5ddd5;
  border-radius: 1.2rem; padding: 2.2rem;
  box-shadow: 0 1px 4px rgba(100,50,30,0.06);
}
.card-header {
  display: flex; align-items: center; gap: 1.4rem;
  margin-bottom: 2rem; padding-bottom: 1.5rem; border-bottom: 1px solid #f0e6de;
}
.step-badge {
  width: 4rem; height: 4rem; border-radius: 50%;
  background: linear-gradient(135deg, #7c2d12, #c2440a);
  display: flex; align-items: center; justify-content: center; flex-shrink: 0;
}
.step-badge svg { width: 1.9rem; height: 1.9rem; stroke: #fff; }
.card-title { font-family: 'DM Serif Display', serif; font-size: 1.8rem; color: #1c0f0a; margin: 0 0 0.2rem; }
.card-desc  { font-size: 1.3rem; color: #9a8070; margin: 0; }

/* ── Table ── */
.table-wrap {
  overflow-x: auto; border: 1px solid #e5ddd5;
  border-radius: 0.8rem; margin-bottom: 2rem;
}
.data-table { width: 100%; border-collapse: collapse; font-size: 1.25rem; }
.data-table thead tr { background: #f0ebe3; }
.data-table th {
  padding: 1rem 1.1rem; text-align: left;
  font-size: 1.1rem; font-weight: 600; color: #4a3028;
  text-transform: uppercase; letter-spacing: 0.05em;
  border-bottom: 2px solid #e5ddd5; white-space: nowrap;
}
.data-table td {
  padding: 0.9rem 1.1rem; color: #1c0f0a;
  border-bottom: 1px solid #f0ebe3; vertical-align: middle;
}
.data-table tbody tr:last-child td { border-bottom: none; }
.data-table tbody tr:hover { background: #fdf9f6; }
.data-table tbody tr:nth-child(even) { background: #faf8f6; }
.data-table tbody tr:nth-child(even):hover { background: #fdf9f6; }

.idx-cell   { color: #9a8070; font-size: 1.15rem; text-align: center; width: 3rem; }
.date-cell  { white-space: nowrap; color: #4a3028; }
.name-cell  { font-weight: 600; }
.addr-cell  { max-width: 16rem; font-size: 1.2rem; color: #4a3028; }
.phone-cell { white-space: nowrap; }
.amount-cell { text-align: right; font-weight: 700; font-variant-numeric: tabular-nums; white-space: nowrap; }
.not-updated { font-size: 1.15rem; color: #9a8070; font-style: italic; font-weight: 400; }
.action-cell { text-align: center; white-space: nowrap; }
.dash { color: #ccc; font-size: 1.4rem; }

/* Service tag */
.service-tag {
  display: inline-block; padding: 0.25rem 0.8rem;
  background: #f0ebe3; color: #7c2d12;
  border-radius: 99px; font-size: 1.1rem; font-weight: 600;
  text-transform: capitalize; white-space: nowrap;
}

/* Status badges */
.status-cell { text-align: center; }
.status-badge {
  display: inline-block; padding: 0.3rem 0.9rem;
  border-radius: 99px; font-size: 1.1rem; font-weight: 600;
  text-transform: capitalize; white-space: nowrap;
}
.status-waiting    { background: #dbeafe; color: #1d4ed8; }
.status-processing { background: #fef9c3; color: #92400e; }
.status-payment    { background: #ccfbf1; color: #0f766e; }
.status-paid       { background: #dcfce7; color: #166534; }
.status-canceled   { background: #fee2e2; color: #991b1b; }

.cancel-reason {
  display: block; font-size: 1.1rem; color: #9a8070; margin-top: 0.3rem;
}

/* Action buttons */
.pay-btn, .delete-btn, .cancel-btn {
  display: inline-flex; align-items: center; gap: 0.4rem;
  padding: 0.45rem 1rem; border-radius: 0.6rem;
  font-family: 'DM Sans', sans-serif; font-size: 1.2rem; font-weight: 600;
  border: none; cursor: pointer; transition: all 0.2s;
}
.pay-btn svg, .delete-btn svg, .cancel-btn svg { width: 1.4rem; height: 1.4rem; flex-shrink: 0; }

.pay-btn {
  background: linear-gradient(135deg, #0f766e, #0d9488);
  color: #fff; box-shadow: 0 2px 8px rgba(13,148,136,0.25);
}
.pay-btn:hover { transform: translateY(-1px); box-shadow: 0 4px 12px rgba(13,148,136,0.35); }

.delete-btn {
  background: #fff; border: 1.5px solid #fca5a5; color: #dc2626;
}
.delete-btn:hover { background: #dc2626; color: #fff; border-color: #dc2626; }

.cancel-btn {
  background: #fff; border: 1.5px solid #e5ddd5; color: #7c2d12;
}
.cancel-btn:hover { background: #7c2d12; color: #fff; border-color: #7c2d12; }

.empty-row {
  text-align: center; color: #9a8070;
  font-size: 1.4rem; padding: 3rem !important;
}

/* ── Pagination ── */
.pagination {
  display: flex; align-items: center; justify-content: flex-end; gap: 1.2rem;
}
.page-btn {
  display: flex; align-items: center; justify-content: center;
  width: 3.4rem; height: 3.4rem;
  border: 1.5px solid #e5ddd5; background: #fff;
  border-radius: 0.6rem; cursor: pointer; transition: all 0.2s; color: #4a3028;
}
.page-btn svg { width: 1.5rem; height: 1.5rem; stroke: currentColor; }
.page-btn:hover:not(:disabled) {
  background: linear-gradient(135deg, #7c2d12, #c2440a);
  border-color: transparent; color: #fff;
}
.page-btn:disabled { opacity: 0.35; cursor: not-allowed; }
.page-info { font-size: 1.35rem; color: #4a3028; font-weight: 500; }

/* ── Legend ── */
.legend-row {
  display: flex; align-items: center; gap: 1.2rem;
  flex-wrap: wrap; margin-top: 1.6rem;
}
.legend-title { font-size: 1.25rem; font-weight: 600; color: #4a3028; margin: 0; }
.legend-items { display: flex; gap: 0.7rem; flex-wrap: wrap; }
.search-wrap {
  display: flex; align-items: center; justify-content: space-between;
  gap: 1rem; flex-wrap: wrap; margin-bottom: 1.4rem;
}
.search-input-wrap {
  display: flex; align-items: center; gap: 0.7rem;
  flex: 1; max-width: 480px;
  background: #faf8f6; border: 2px solid #e5ddd5;
  border-radius: 0.7rem; padding: 0.55rem 1rem;
  transition: border-color 0.2s;
}
.search-input-wrap:focus-within { border-color: #c2440a; background: #fff; }
.search-input-wrap svg { width: 1.6rem; height: 1.6rem; stroke: #9a8070; flex-shrink: 0; }
.search-input {
  flex: 1; border: none; background: transparent;
  font-family: 'DM Sans', sans-serif; font-size: 1.3rem;
  color: #1c0f0a; outline: none;
}
.search-input::placeholder { color: #b0a09a; }
.search-clear {
  background: none; border: none; cursor: pointer;
  font-size: 1.2rem; color: #9a8070; padding: 0 0.2rem;
  transition: color 0.2s;
}
.search-clear:hover { color: #c2440a; }
.search-count { font-size: 1.25rem; color: #9a8070; white-space: nowrap; }
/* ── Responsive ── */
@media (max-width: 768px) {
  .history-page { padding: 1.5rem 1rem 3rem; }
  .page-title   { font-size: 2rem; }
  .page-header  { flex-direction: column; }
  .form-card    { padding: 1.5rem; }
  .data-table th, .data-table td { padding: 0.75rem 0.8rem; font-size: 1.15rem; }
  .legend-row   { flex-direction: column; align-items: flex-start; }
}
</style>